import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Immutable from "immutable";
import uuid from "./uuid";
import { getFieldConfig, getOperatorConfig, getFieldParts, getFirstField } from "./configUtils";
import { getFirstOperator } from "../utils/ruleUtils";
import { getNewValueForFieldOp } from "../utils/validation";
import { isImmutable, isImmutableList } from "./stuff";
import { jsToImmutable } from "../import";
export var getDefaultField = function getDefaultField(config) {
  var canGetFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var parentRuleGroupField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var defaultField = config.settings.defaultField;
  var f = (!parentRuleGroupField ? defaultField : getDefaultSubField(config, parentRuleGroupField)) || canGetFirst && getFirstField(config, parentRuleGroupField) || null;
  // if default LHS is func, convert to Immutable
  if (f != null && typeof f !== "string" && !isImmutable(f)) {
    f = jsToImmutable(f);
  }
  return f;
};
export var getDefaultSubField = function getDefaultSubField(config) {
  var _config$settings;
  var parentRuleGroupField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!parentRuleGroupField) return null;
  var fieldSeparator = (config === null || config === void 0 || (_config$settings = config.settings) === null || _config$settings === void 0 ? void 0 : _config$settings.fieldSeparator) || ".";
  var parentRuleGroupConfig = getFieldConfig(config, parentRuleGroupField);
  var f = parentRuleGroupConfig === null || parentRuleGroupConfig === void 0 ? void 0 : parentRuleGroupConfig.defaultField;
  if (f) {
    f = [].concat(_toConsumableArray(getFieldParts(parentRuleGroupField)), [f]).join(fieldSeparator);
  }
  return f;
};
export var getDefaultFieldSrc = function getDefaultFieldSrc(config) {
  var _config$settings$fiel;
  var canGetFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return canGetFirst && ((_config$settings$fiel = config.settings.fieldSources) === null || _config$settings$fiel === void 0 ? void 0 : _config$settings$fiel[0]) || "field";
};
export var getDefaultOperator = function getDefaultOperator(config, field) {
  var canGetFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var fieldConfig = getFieldConfig(config, field);
  var fieldOperators = (fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.operators) || [];
  var globalDefaultOperator = config.settings.defaultOperator;
  if (globalDefaultOperator && !fieldOperators.includes(globalDefaultOperator)) globalDefaultOperator = null;
  var fieldDefaultOperator = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.defaultOperator;
  var fieldOwnDefaultOperator = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.ownDefaultOperator;
  var firstOperator = canGetFirst ? getFirstOperator(config, field) : null;
  var op = fieldOwnDefaultOperator || globalDefaultOperator || fieldDefaultOperator || firstOperator;
  return op;
};

//used for complex operators like proximity
export var defaultOperatorOptions = function defaultOperatorOptions(config, operator, field) {
  var operatorConfig = operator ? getOperatorConfig(config, operator, field) : null;
  if (!operatorConfig) return null; //new Immutable.Map();
  return operatorConfig.options ? new Immutable.Map(operatorConfig.options && operatorConfig.options.defaults || {}) : null;
};
export var defaultRuleProperties = function defaultRuleProperties(config) {
  var parentRuleGroupField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var canUseDefaultFieldAndOp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var canGetFirst = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var field = null,
    operator = null,
    fieldSrc = null;
  var showErrorMessage = config.settings.showErrorMessage;
  if (item) {
    var _item$properties, _item$properties2, _item$properties3;
    fieldSrc = item === null || item === void 0 || (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties.fieldSrc;
    field = item === null || item === void 0 || (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2.field;
    operator = item === null || item === void 0 || (_item$properties3 = item.properties) === null || _item$properties3 === void 0 ? void 0 : _item$properties3.operator;
  } else if (canUseDefaultFieldAndOp) {
    field = getDefaultField(config, canGetFirst, parentRuleGroupField);
    if (field) {
      fieldSrc = isImmutable(field) ? "func" : "field";
    } else {
      fieldSrc = getDefaultFieldSrc(config);
    }
    operator = getDefaultOperator(config, field, true);
  } else {
    fieldSrc = getDefaultFieldSrc(config);
  }
  var current = new Immutable.Map({
    fieldSrc: fieldSrc,
    field: field,
    operator: operator,
    value: new Immutable.List(),
    valueSrc: new Immutable.List(),
    //used for complex operators like proximity
    operatorOptions: defaultOperatorOptions(config, operator, field)
  });
  if (showErrorMessage) {
    current = current.set("valueError", new Immutable.List());
  }
  if (field && operator) {
    var canFix = false;
    var _getNewValueForFieldO = getNewValueForFieldOp(config, config, current, field, operator, "operator", canFix),
      newValue = _getNewValueForFieldO.newValue,
      newValueSrc = _getNewValueForFieldO.newValueSrc,
      newValueType = _getNewValueForFieldO.newValueType,
      newValueError = _getNewValueForFieldO.newValueError,
      newFieldError = _getNewValueForFieldO.newFieldError;
    current = current.set("value", newValue).set("valueSrc", newValueSrc).set("valueType", newValueType);
    if (showErrorMessage) {
      current = current.set("valueError", newValueError).set("fieldError", newFieldError);
    }
  }
  var fieldConfig = getFieldConfig(config, field);
  if ((fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.type) === "!group") {
    var conjunction = defaultGroupConjunction(config, fieldConfig);
    current = current.set("conjunction", conjunction);
  }
  return current;
};
export var defaultGroupConjunction = function defaultGroupConjunction(config) {
  var _groupFieldConfig, _groupFieldConfig2;
  var groupFieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  groupFieldConfig = getFieldConfig(config, groupFieldConfig); // if `groupFieldConfig` is field name, not config
  var conjs = ((_groupFieldConfig = groupFieldConfig) === null || _groupFieldConfig === void 0 ? void 0 : _groupFieldConfig.conjunctions) || Object.keys(config.conjunctions);
  if (conjs.length == 1) return conjs[0];
  // todo: config.settings.defaultGroupConjunction is deprecated, defaultConjunction should be used instead
  return ((_groupFieldConfig2 = groupFieldConfig) === null || _groupFieldConfig2 === void 0 ? void 0 : _groupFieldConfig2.defaultConjunction) || config.settings.defaultConjunction || config.settings.defaultGroupConjunction || conjs[0];
};

// @deprecated Use defaultGroupConjunction
export var defaultConjunction = function defaultConjunction(config) {
  return defaultGroupConjunction(config);
};
export var defaultGroupProperties = function defaultGroupProperties(config) {
  var groupFieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Immutable.Map({
    conjunction: defaultGroupConjunction(config, groupFieldConfig),
    not: false
  });
};
export var defaultItemProperties = function defaultItemProperties(config, item) {
  return (item === null || item === void 0 ? void 0 : item.type) == "group" ? defaultGroupProperties(config) : defaultRuleProperties(config, null, item);
};
export var defaultRule = function defaultRule(id, config) {
  return _defineProperty({}, id, new Immutable.Map({
    type: "rule",
    id: id,
    properties: defaultRuleProperties(config)
  }));
};
export var defaultRoot = function defaultRoot(config) {
  var canAddDefaultRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Immutable.Map({
    type: "group",
    id: uuid(),
    children1: new Immutable.OrderedMap(canAddDefaultRule ? _objectSpread({}, defaultRule(uuid(), config)) : {}),
    properties: defaultGroupProperties(config)
  });
};
export var createListWithOneElement = function createListWithOneElement(el) {
  if (isImmutableList(el)) return el; // already Immutable list
  return createListFromArray([el]);
};
export var createListFromArray = function createListFromArray(arr) {
  if (isImmutableList(arr)) return arr; // already Immutable list
  return new Immutable.List(arr);
};
export var emptyProperties = function emptyProperties() {
  return new Immutable.Map();
};